<script>
	import Home from "./home/Home.svelte";
    import Faq from "./faq/Faq.svelte";
	import LegalDoc from "./legal/LegalDoc.svelte";
	import Page404 from "./page404/Page404.svelte";
    import Header from "./Header.svelte";
    import Footer from "./Footer.svelte";
	import GdprConsent from "./GdprConsent.svelte";

	let hash = window.location.hash;

	window.addEventListener("hashchange", () => {
		hash = window.location.hash;
	});
</script>

<main class="container">
    <Header />
	{#if hash == "" || hash.length <= 2 || hash[1] != "/"}
        <Home />
	{:else if hash == "#/docs"}
		<Faq />
	{:else if hash == "#/legal/privacy-policy"}
		<LegalDoc name="Privacy Policy" legalDocName="privacy-policy" />
	{:else if hash == "#/legal/terms-and-conditions"}
		<LegalDoc name="Terms and Conditions" legalDocName="terms-and-conditions" />
    {:else}
		<Page404 />
	{/if}
	<div class="buffer" />
    <Footer />
	<GdprConsent />
</main>

<style>
	.container {
		display: flex;
		flex-flow: column nowrap;
		min-height: 100%;
		min-width: 100%;
	}

	.buffer {
		flex: 1 1 1px
	}
</style>